export default class ConversationController {  

  constructor($scope, $rootScope, $state, $stateParams, XucChat) {
    $scope.remoteParty = $stateParams.remoteParty;
    $scope.remotePartyHint = "4";

    $scope.getStatusClass = () => {
      return `user-status${$scope.remotePartyHint}`;
    };

    $rootScope.$on(XucChat.CURRENT_CHAT_LINESTATUS, (event, data) => {
      $scope.remotePartyHint = data;
    });

    $scope.gotoConversationHistory = () => {
      $state.go("interface.conversationHistory");
    };
  }
}
